module.exports = __webpack_public_path__ + "img/tddd.12ce36fc.png";